import { StepBackwardOutlined } from '@ant-design/icons';
import { Col, Row, Form, Input, InputNumber, Select, Checkbox } from 'antd';
import { useContext, useEffect, useState } from 'react';
import { PageContext } from '../../../../lib/context';

const RolesForm = () => {
  const { form, _onFinish, display, option, settings, setSettings } =
    useContext(PageContext);
  const { Option } = Select;
  const [password, setPassword] = useState('');
  const [role, setRole] = useState<number>();

  const handleChange = (value: number) => {
    setRole(value);
  };

  const handlePass = (e: any) => {
    setPassword(e.target.value);
  };

  return (
    <Form layout="vertical" form={form} onFinish={_onFinish}>
      <Row>
        <Col span={12}>
          <Form.Item
            label="Role Name"
            name="name"
            rules={[{ required: true, message: 'Username is required' }]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>
      {Object.keys(settings).map(k => {
        return (
          <Row>
            <Col span={12}>
              <Form.Item>
                <Checkbox
                  onChange={() =>
                    setSettings({
                      ...settings,
                      [k]: !settings[k],
                    })
                  }
                  checked={settings[k]}
                >
                  {k.toUpperCase()}
                </Checkbox>
              </Form.Item>
            </Col>
          </Row>
        );
      })}
    </Form>
  );
};

export default RolesForm;
